'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useClient } from 'ui-hooks/useClient';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { useCallback } from 'react';
import { buildSignInUrl } from 'utils/url';

export const useRequestSign = () => {
  const pathname = usePathname();
  const router = useRouter();
  const client = useClient();
  return useCallback(() => {
    if (client.isWeb) {
      router.push(buildSignInUrl(pathname ?? ''));
    } else {
      DirittoAppBridge.openSign();
    }
  }, [client.isWeb, router, pathname]);
};
